import { store } from '@redux/store';
import { searchParametersActions } from 'features/searchResultsFacets';
import { fromEvent } from "rxjs";

const pageSizeElement = document.querySelector('[data-page-size]');
const pageSizeChange$ = fromEvent(pageSizeElement, 'change');

/**
 * pageSizeChangeHandler: Handles the page size changes.
 * @param {Event} event Change event object
 */
function pageSizeChangeHandler(event) {
  const newPageSize = parseInt(event.target.value, 10);
  store.dispatch(searchParametersActions.fetchPageSize(newPageSize));
}

pageSizeChange$.subscribe(pageSizeChangeHandler);

